import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useDeleteApplicationAccountMutation} from '../hooks/useApplicationAccountsQuery';
import {useApplicationAccountsSelection} from "../hooks/useApplicationAccountsSelection.ts";


export const DeleteRecordButton = () => {

    const deleteApplicationAccountMutation = useDeleteApplicationAccountMutation();

    const {
        selection,
        handleClearSelection,
    } = useApplicationAccountsSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    // FNP-795: a rejected row must not abort the rest of the batch.
    //
    // console-api now REJECTS deleting an ACTIVE AccountApplication (it is an
    // occupied seat — deleting it would destroy the deactivation timestamp prorated
    // billing is computed from). That makes a mid-batch failure a NORMAL outcome of
    // a multi-select, not just an outage: previously `mutateAsync` rejected, every
    // row after the failing one was silently skipped, `handleClearSelection()` never
    // ran so the selection stuck, and the rejection escaped as an unhandled promise.
    //
    // Each row is now independent. The mutation's own `onError: notifyError` already
    // shows the server's message — which names the required action ("deactivate
    // first"), reachable from the row's edit drawer — so the user learns exactly
    // which rows were refused and what to do, while the deletable ones still go.
    const handleDelete = async () => {
        for (const id of recordIds) {
            try {
                await deleteApplicationAccountMutation.mutateAsync(id);
            } catch {
                // Already surfaced by onError; keep going so one occupied seat does
                // not block the rest of the selection.
            }
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);

};
